import product1 from '../../../assets/images/dashboard/best-selling/1.png';
import product2 from '../../../assets/images/dashboard/best-selling/2.png';
import product3 from '../../../assets/images/dashboard/best-selling/3.png';
import product4 from '../../../assets/images/dashboard/best-selling/4.png';
export const BEST_SELLING_PRODUCT = [
  {
    title: 'Nike Shoes',
    image: product1,
    date: '16 August',
    gros: 65.0,
    status: 'Done',
  },
  {
    title: 'Headphone',
    image: product2,
    date: '02 October',
    gros: 95.0,
    status: 'Done',
  },
  {
    title: 'Tree Plant',
    image: product3,
    date: '12 March',
    gros: 2.0,
    status: 'Done',
  },
  {
    title: 'Handbags',
    image: product4,
    date: '31 December',
    gros: 43.0,
    status: 'Done',
  },
];
